module.exports = __webpack_public_path__ + "img/hero.fecff494.png";